module.exports = new __parcel__URL__("nighttime-lights--dataset-cover.1cd08e26.jpg").toString();